@if (ready) {
  @if (link) {
    <mat-icon fontSet="material-icons" fontIcon="open_in_new" matTooltipPosition="below" [matTooltip]="link" class="grid-external-link"></mat-icon>
  } @else {
    <span>{{ emptyValue }}</span>
  }
}
